import { useEffect, useState } from 'react';
import { Size } from '../../../constants/commonEnums';
import { LoaderWithWrapper } from '../../Atoms/Loader';
import { IndividiualsRewardCard } from './IndividualRewardCard';
import { cleartaxAxios } from '../../../http-common';

export interface rewardList {
  id: number;
  rewardDescription: string;
  backgroundUrl: string;
  category: string;
  logoUrl: string;
}

const RewardCategory = (): JSX.Element => {
  const [category, setCategory] = useState<string[]>([]);
  const [rewards, setRewards] = useState<Array<rewardList>>([]);
  const [loader, setLoader] = useState<boolean>(false);

  const getRewards = () => {
    cleartaxAxios
      .get('/Rewards/GetAllRewards')
      .then((response) => {
        try {
          const data = response.data;
          const categoryList = [];
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].category &&
              categoryList.indexOf(data[i].category) === -1
            ) {
              categoryList.push(data[i].category);
            }
          }
          setRewards(data);
          setCategory(categoryList);
          setLoader(true);
        } catch (error) {
          console.log(error);
          setLoader(true);
        }
      })
      .catch((e: Error) => {
        console.log(e);
        setLoader(true);
      });
  };

  useEffect(() => {
    getRewards();
  }, []);

  return (
    <>
      <LoaderWithWrapper
        size={Size.LARGE}
        loadingLabel="Loading"
        loading={!loader}
      >
        {category &&
          category.length > 0 &&
          category.map((res: string) => (
            <div className="py-12" key={res}>
              <h2 className="pl-4 sm:pl-0">
                {res?.replace('&amp;', '&') || ''}
              </h2>
              <div className="flex flex-wrap pt-6">
                {IndividiualsRewardCard(res, rewards)}
              </div>
            </div>
          ))}
      </LoaderWithWrapper>
    </>
  );
};

export default RewardCategory;
